import axios from '@/utils/request'

const detailListUrl = '/data/contractRewardDailyDetail/detail/page'
const detailList = async (body) => {
  const { data } = await axios.post(detailListUrl, body)
  return data.data
}

const recordListUrl = '/data/contractRewardDailyDetail/own/page'
const recordList = async (body) => {
  const { data } = await axios.post(recordListUrl, body)
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  detailList,
  recordList,
}
